/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 200 ok object
 * @export
 * @interface GetCharactersCharacterIdAttributesOk
 */
export interface GetCharactersCharacterIdAttributesOk {
    /**
     * Neural remapping cooldown after a character uses remap accrued over time
     * @type {Date}
     * @memberof GetCharactersCharacterIdAttributesOk
     */
    accruedRemapCooldownDate?: Date;
    /**
     * Number of available bonus character neural remaps
     * @type {number}
     * @memberof GetCharactersCharacterIdAttributesOk
     */
    bonusRemaps?: number;
    /**
     * charisma integer
     * @type {number}
     * @memberof GetCharactersCharacterIdAttributesOk
     */
    charisma: number;
    /**
     * intelligence integer
     * @type {number}
     * @memberof GetCharactersCharacterIdAttributesOk
     */
    intelligence: number;
    /**
     * Datetime of last neural remap, including usage of bonus remaps
     * @type {Date}
     * @memberof GetCharactersCharacterIdAttributesOk
     */
    lastRemapDate?: Date;
    /**
     * memory integer
     * @type {number}
     * @memberof GetCharactersCharacterIdAttributesOk
     */
    memory: number;
    /**
     * perception integer
     * @type {number}
     * @memberof GetCharactersCharacterIdAttributesOk
     */
    perception: number;
    /**
     * willpower integer
     * @type {number}
     * @memberof GetCharactersCharacterIdAttributesOk
     */
    willpower: number;
}

/**
 * Check if a given object implements the GetCharactersCharacterIdAttributesOk interface.
 */
export function instanceOfGetCharactersCharacterIdAttributesOk(value: object): value is GetCharactersCharacterIdAttributesOk {
    if (!('charisma' in value) || value['charisma'] === undefined) return false;
    if (!('intelligence' in value) || value['intelligence'] === undefined) return false;
    if (!('memory' in value) || value['memory'] === undefined) return false;
    if (!('perception' in value) || value['perception'] === undefined) return false;
    if (!('willpower' in value) || value['willpower'] === undefined) return false;
    return true;
}

export function GetCharactersCharacterIdAttributesOkFromJSON(json: any): GetCharactersCharacterIdAttributesOk {
    return GetCharactersCharacterIdAttributesOkFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdAttributesOkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdAttributesOk {
    if (json == null) {
        return json;
    }
    return {
        
        'accruedRemapCooldownDate': json['accrued_remap_cooldown_date'] == null ? undefined : (new Date(json['accrued_remap_cooldown_date'])),
        'bonusRemaps': json['bonus_remaps'] == null ? undefined : json['bonus_remaps'],
        'charisma': json['charisma'],
        'intelligence': json['intelligence'],
        'lastRemapDate': json['last_remap_date'] == null ? undefined : (new Date(json['last_remap_date'])),
        'memory': json['memory'],
        'perception': json['perception'],
        'willpower': json['willpower'],
    };
}

export function GetCharactersCharacterIdAttributesOkToJSON(json: any): GetCharactersCharacterIdAttributesOk {
    return GetCharactersCharacterIdAttributesOkToJSONTyped(json, false);
}

export function GetCharactersCharacterIdAttributesOkToJSONTyped(value?: GetCharactersCharacterIdAttributesOk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accrued_remap_cooldown_date': value['accruedRemapCooldownDate'] == null ? undefined : ((value['accruedRemapCooldownDate']).toISOString()),
        'bonus_remaps': value['bonusRemaps'],
        'charisma': value['charisma'],
        'intelligence': value['intelligence'],
        'last_remap_date': value['lastRemapDate'] == null ? undefined : ((value['lastRemapDate']).toISOString()),
        'memory': value['memory'],
        'perception': value['perception'],
        'willpower': value['willpower'],
    };
}

